import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();
  
  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter(x => x);
    const breadcrumbs = [];
    
    let currentPath = '';
    
    pathnames.forEach((name, index) => {
      currentPath += `/${name}`;
      
      // Mapear nomes amigáveis para as rotas
      let displayName = name;
      switch (name) {
        case 'hotel-settings':
          displayName = 'Gerenciamento de Hotéis';
          break;
        case 'user-management':
          displayName = 'Gerenciamento de Usuários';
          break;
        case 'room-management':
          displayName = 'Gerenciamento de Quartos';
          break;
        case 'reservations':
          displayName = 'Reservas';
          break;
        case 'dashboard':
          displayName = 'Dashboard';
          break;
        case 'reports-and-analytics':
          displayName = 'Relatórios e Análises';
          break;
        case 'financial-management':
          displayName = 'Gestão Financeira';
          break;
        case 'settings':
          displayName = 'Configurações';
          break;
        default:
          // Capitalizar primeira letra e substituir hífens por espaços
          displayName = name
            .replace(/-/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase());
      }
      
      breadcrumbs.push({
        name: displayName,
        path: currentPath,
        isLast: index === pathnames.length - 1
      });
    });
    
    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      <Link 
        to="/dashboard" 
        className="flex items-center space-x-2 hover:text-foreground transition-colors"
      >
        <Icon name="Home" size={16} />
        <span>Início</span>
      </Link>
      
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.path}>
          <Icon name="ChevronRight" size={16} />
          {breadcrumb.isLast ? (
            <span className="text-foreground font-medium">
              {breadcrumb.name}
            </span>
          ) : (
            <Link 
              to={breadcrumb.path}
              className="hover:text-foreground transition-colors"
            >
              {breadcrumb.name}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;